'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Down = require('./Down');

var _Down2 = _interopRequireDefault(_Down);

var _Up = require('./Up');

var _Up2 = _interopRequireDefault(_Up);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Exports
 */

exports.default = {
  Down: _Down2.default,
  Up: _Up2.default
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Arrows/medium/index.js
// module id = 1110
// module chunks = 1